export const SET_GETSHORTCODE = "SET_GETSHORTCODE";
export const SET_GETLINK = "SET_SETCREATELINK";
export const SET_SETSAVESHORTCODELINK = "SET_SETSAVESHORTCODELINK";